export const STORE_APP_MUTATION_TYPES = {}

STORE_APP_MUTATION_TYPES.INIT_TOP_TAB_LIST = 'initTopTabList'
STORE_APP_MUTATION_TYPES.ADD_ONE_TOP_TAB = 'addOneTopTab'
STORE_APP_MUTATION_TYPES.REMOVE_TAB_BY_ID = 'removeTabByName'
STORE_APP_MUTATION_TYPES.INIT_CACHED_VIEWS = 'initCachedViews'
STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS = 'removeCachedViews'
STORE_APP_MUTATION_TYPES.ADD_CACHED_VIEWS = 'addCachedViews'
STORE_APP_MUTATION_TYPES.INIT_CURRENT_PAGE = 'initCurrentPage'
STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_PAGE = 'updateCurrentPage'
STORE_APP_MUTATION_TYPES.INIT_CURRENT_TAB = 'initCurrentTab'
STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_ROUTES_FORWARD = 'updateCurrentRoutesForward'
STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_ROUTES_BACK = 'updateCurrentRoutesBack'
STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_LEFT_MENU = 'updateCurrentLeftMenu'
STORE_APP_MUTATION_TYPES.SET_SHOW_LEFT_MENU = 'setShowLeftMenu'
STORE_APP_MUTATION_TYPES.CLOSE_OTHER_TABS = 'closeOtherTabs'
STORE_APP_MUTATION_TYPES.CLOSE_ALL_TABS = 'closeAllTabs'
STORE_APP_MUTATION_TYPES.SHOW_IFRAME = 'showIframe'
STORE_APP_MUTATION_TYPES.HIDDEN_IFRAME = 'hiddenIframe'
STORE_APP_MUTATION_TYPES.STORE_TOPTABLIST = 'storeTopTabList'
STORE_APP_MUTATION_TYPES.INIT_SITE_DETAIL_INFO = 'initSiteDetailInfo'
STORE_APP_MUTATION_TYPES.RESET_APP_STATE = 'resetAppState'
STORE_APP_MUTATION_TYPES.SET_DEFAULT_MENU = 'setDefaultMenu'
STORE_APP_MUTATION_TYPES.CLEAR_ONE_TAB_CACHE = 'clearOneTabCache'

export const STORE_PERMISSION_MUTATION_TYPES = {}
STORE_PERMISSION_MUTATION_TYPES.ROUTERS_INITIALIZED = 'initRouters'
STORE_PERMISSION_MUTATION_TYPES.RESET_PERMISSION_STATE = 'resetPermissionState'

export const STORE_PERMISSION_ACTIONS_TYPES = {}
STORE_PERMISSION_ACTIONS_TYPES.INIT_ROUTERS = 'initRouters'

export const STORE_USER_MUTATION_TYPES = {}
STORE_USER_MUTATION_TYPES.RESET_USER_STATE = 'resetUserState'

export const STORE_APP_STORAGE_KEYS = {}
STORE_APP_STORAGE_KEYS.CURRENT_PAGE_ID = '_currentPageId'
STORE_APP_STORAGE_KEYS.CURRENT_TAB = '_currentTab'
STORE_APP_STORAGE_KEYS.TOP_TAB_LIST = '_topTabList'

export const ELEMENT_DATE_PICKER_OPTIONS_1 = {
  firstDayOfWeek: 1,
  shortcuts: [
    // {
    //   text: '选范围',
    //   onClick(picker) {
    //     console.log(picker)
    //     console.log(picker.type)
    //   }
    // },
    // {
    //   text: '选天',
    //   onClick(picker) {
    //     console.log(picker)
    //   }
    // },
    {
      text: '本周',
      onClick(picker) {
        const start = new Date()
        let n = start.getDay()
        if (n === 0) {
          n = 7
        }
        start.setDate(start.getDate() - n + 1)
        const end = new Date(start.getTime() + 3600 * 1000 * 24 * 6)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '上周',
      onClick(picker) {
        const start = new Date()
        start.setDate(start.getDate() - 7)
        let n = start.getDay()
        if (n === 0) {
          n = 7
        }
        start.setDate(start.getDate() - n + 1)
        const end = new Date(start.getTime() + 3600 * 1000 * 24 * 6)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '本月',
      onClick(picker) {
        const now = new Date()
        const start = new Date(now.getFullYear(), now.getMonth(), 1)
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 1)
        end.setDate(end.getDate() - 1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '上月',
      onClick(picker) {
        let now = new Date()
        now = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        const start = new Date(now.getFullYear(), now.getMonth(), 1)
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 1)
        end.setDate(end.getDate() - 1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '本年',
      onClick(picker) {
        const now = new Date()
        const start = new Date(now.getFullYear(), 0, 1)
        const end = new Date(now.getFullYear() + 1, 0, 1)
        end.setDate(end.getDate() - 1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '上年',
      onClick(picker) {
        let now = new Date()
        now = new Date(now.getFullYear() - 1, 0, 1)
        const start = new Date(now.getFullYear(), 0, 1)
        const end = new Date(now.getFullYear() + 1, 0, 1)
        end.setDate(end.getDate() - 1)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/libs/constants.js